<script lang="typescript">
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();
    // two way binding and reactive...
    // we dont need to put $ in the same time
    export let value = false;

    $: disabled = false;
    $: style = "margin: 0 16px;";
    
    const onClick = () => {
        value = !value;
        dispatch("change", { value });

    };
</script>

<div
    class="switch"
    class:disabled
    class:true={value}
    class:false={!value}
    {style}
    on:click={onClick}
>
    <div class="bg" />
    <span class="thumb" class:checked={value} />
</div>

<style>
    :root {
        --switch-color-true: var(--color-primary, #bb86fc);
        --switch-color-false: var(--color-level-4, #595959);
    }
    .disabled {
        pointer-events: none;

        opacity: 0.38;
    }
    .false .bg,
    .false .thumb {
        background: var(--switch-color-false);
    }
    .true .bg,
    .true .thumb {
        background: var(--switch-color-true);
    }
    .true .thumb {
        right: 0px;
    }

    .switch {
        align-items: center;
        display: flex;
        width: 34px;
        justify-content: center;
        height: 34px;
        position: relative;
        cursor: pointer;
    }
    .bg {
        width: 34px;
        height: 14px;
        border-radius: 7px;
        opacity: 0.38;
    }

    .thumb {
        position: absolute;
        width: 20px;
        height: 20px;
        right: 14px;
        border-radius: 50%;

        transition: right 0.2s cubic-bezier(0.165, 0.84, 0.44, 1);
    }
</style>
